import React from "react";
import { Container } from "react-bootstrap";
import { codeBanner } from "./styles.mod.scss";

const CodeBanner = ({ data }) => {
  const bgColor = data?.bgColor?.hex;
  const textColor = data?.textColor?.hex;

  return (
    <div className={codeBanner} style={{ backgroundColor: bgColor }}>
      <Container>
        <p style={{ color: textColor }}>{data?.text}</p>
      </Container>
    </div>
  );
};

export default CodeBanner;